<template>
    <div class="p-fluid formgroup-inline grid">
        <div class="field col-4">Test Name</div>
        <div class="field col-3">Date</div>
        <div class="field col-2">Skor</div>
        <div class="field col-2">Status</div>
    </div>
    <div v-for="(item, index) in assessmentResults" class="p-fluid formgroup-inline grid">
        <div class="field col-4">
            <label for="name" class="p-sr-only">Name</label>
            <Dropdown v-model="item.name" :options="optionValues" optionLabel="name" optionValue="code" placeholder="Select type of test" />
        </div>
        <div class="field col-3">
            <label for="selection_date" class="p-sr-only">Selection Date</label>
            <Calendar :showIcon="true"
                    :showButtonBar="true"
                    v-model="item.selection_date"
                    :class="{'p-invalid' : submitted && !item.selection_date}"
                    dateFormat="yy-mm-dd">
            </Calendar>
        </div>
        <div class="field col-2">
            <label for="score" class="p-sr-only">Score</label>
            <InputText id="score" type="text" placeholder="Score" v-model="item.score" @input="checkScore(index, item.score)"/>
        </div>
        <div class="field col-2">
            <span :class="'applicant-badge status-' + item.status">{{ item.status }}</span>
        </div>
    </div>
    <div>
        Total Score : {{ totalSummaries }}
    </div>
    <div>
        Result : {{ testResult }}
    </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import axios from "axios";

export default{
    components:{
        Dropdown, Calendar, InputText,
    },
    props: ['models'],
    data() {
        return {
            assessmentResults: [
                {selection_date: "2022-09-12", score: 0, code: 'administrasi', grade: ''},
                {selection_date: "2022-09-13", score: 0, code: 'administrasi', grade: ''},
                {selection_date: "2022-09-14", score: 0, code: 'administrasi', grade: ''},
                {selection_date: "2022-09-15", score: 0, code: 'administrasi', grade: ''},
                {selection_date: "2022-09-16", score: 0, code: 'administrasi', grade: ''},
            ],
            optionValues: [
                {name: 'Administrasi', code: 'administrasi'},
                {name: 'Psikotest/Tertulis', code: 'psikotest'},
                {name: 'Wawancara Internal', code: 'wawancara-internal'},
                {name: 'Wawancara External', code: 'wawancara-external'},
                {name: 'Medical Checkup', code: 'mcu'},
            ],
            submitted: false,
        }
    },
    computed: {
        totalSummaries() {
            let totalSummary = this.assessmentResults.reduce((total, item) => parseInt(item.score) + total, 0);
            return totalSummary / 5
        },
        testResult(){
            let totalSummary = this.assessmentResults.reduce((total, item) => parseInt(item.score) + total, 0);
            if(totalSummary / 5 >= 50){
                return "Success";
            }
            else{
                return "Failed";
            }
        }
    },
    mounted(){
        this.loadAssessementResults();
    },
    methods: {
        checkScore(index, score) {
            let status = '';

            if(score >= 50 && score <= 100){
                this.assessmentResults[index].status = 'pass';
                status = "pass";
            }
            else{
                this.assessmentResults[index].status = 'fail';
                status = 'fail';
            }
        },
        loadAssessementResults(){
            const rawObject = {...this.models[0]};

            this.selectionTestDialog = true;
            axios.get(`${this.$page.props.appUrl}api/applicant-assessements/${rawObject.id}`)
            .then((data) => {
                this.assessmentResults = data.data.data;
            });
        },
    }
}
</script>
<style>
@import "../../../../assets/demo/badges.scss";
</style>
